<script lang="ts">
    import { apiBaseURL } from "../../../config"
    export let subPointId
    import { fly } from "svelte/transition"
    export let person
</script>

<div class="person-card" in:fly="{{ y: 80, opacity: 0, duration: 750 }}">
    <div class="profile-img-container">
        <img src="{`${apiBaseURL}subpoint/${subPointId}/${person.image?.src}`}" alt="img" />
    </div>
    <div class="description">
        <div class="name">{person.Name}</div>
        <div class="desc">{@html person.shortDescription}</div>
    </div>
</div>

<style lang="less">
    .person-card {
        display: flex;
        width: 100%;
        gap: 20px;
        .profile-img-container {
            flex-shrink: 0;
            width: 140px;
            height: 200px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .description {
            display: flex;
            flex-direction: column;
            gap: 6px;
            .name {
                font-weight: bold;
            }
            .vita {
                height: 34px;
                gap: 5px;
                display: flex;
                align-items: center;
                span {
                    height: fit-content;
                }
            }
        }
    }
</style>
